<template>
  <div>
    <app-lightbox
      id="mylightbox"
      :images="images"
      :image_class=" 'img-fluid rounded' "
      :album_class=" 'my-album-class' "
      :options="options">
    </app-lightbox>
  </div>
</template>

<script>
    import Lightbox from 'vue-simple-lightbox'

    export default {
        props: ['images'],        
        components: {
            appLightbox: Lightbox
        },
        data(){
            return {
                options: {
                    closeText : 'X'
                }
            }
        },
        components: {
            appLightbox: Lightbox
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Helpers/lightBox.vue